module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/YK4352_login.1a95f853.png";